import script from "./activitySubmit.vue?vue&type=script&setup=true&lang=js"
export * from "./activitySubmit.vue?vue&type=script&setup=true&lang=js"

import "./activitySubmit.vue?vue&type=style&index=0&id=41df430a&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-agent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41df430a"]])

export default __exports__